import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarPlus } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const stamp = (iso) => {
  const d = new Date(iso);
  return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
};

function details(b, t) {
  const other = [b.expert_name, b.employee_name].filter(Boolean).join(" & ");
  const parts = [other ? t("cal.withNames", { names: other }) : "", b.meeting_link ? t("cal.joinLink", { link: b.meeting_link }) : ""].filter(Boolean);
  return parts.join("\n");
}

function googleUrl(b, t) {
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `Compeni: ${b.topic || "Coaching session"}`,
    dates: `${stamp(b.start)}/${stamp(b.end)}`,
    details: details(b, t),
    location: b.meeting_link || "",
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

function outlookUrl(b, t) {
  const p = new URLSearchParams({
    path: "/calendar/action/compose", rru: "addevent",
    subject: `Compeni: ${b.topic || "Coaching session"}`,
    startdt: new Date(b.start).toISOString(), enddt: new Date(b.end).toISOString(),
    body: details(b, t), location: b.meeting_link || "",
  });
  return `https://outlook.office.com/calendar/0/deeplink/compose?${p.toString()}`;
}

function downloadIcs(b, t) {
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Compeni//EN", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${b.booking_id || Date.now()}@compeni`,
    `DTSTAMP:${stamp(new Date().toISOString())}`,
    `DTSTART:${stamp(b.start)}`,
    `DTEND:${stamp(b.end)}`,
    `SUMMARY:Compeni: ${b.topic || "Coaching session"}`,
    `DESCRIPTION:${details(b, t).replace(/\n/g, "\\n")}`,
    `LOCATION:${b.meeting_link || ""}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `compeni-session.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function AddToCalendar({ booking, size = "sm", label }) {
  const { t } = useTranslation();
  const btnLabel = label || t("cal.addToCalendar");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`addcal-${booking.booking_id}`}
          className="inline-flex items-center gap-1.5 rounded-lg border border-border px-2.5 h-8 text-xs font-medium text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors bg-card">
          <CalendarPlus size={14} /> {btnLabel}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuItem asChild><a href={googleUrl(booking, t)} target="_blank" rel="noreferrer" data-testid="addcal-google">{t("cal.addGoogle")}</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a href={outlookUrl(booking, t)} target="_blank" rel="noreferrer" data-testid="addcal-outlook">{t("cal.addOutlook")}</a></DropdownMenuItem>
        <DropdownMenuItem onClick={() => downloadIcs(booking, t)} data-testid="addcal-ics">{t("cal.addIcs")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
